import {
  Box,
  Skeleton,
  Stack,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { useCallback } from 'react';

import useAppointmentStore, {
  isInBranchAppointment as isInBranchAppointmentSelector,
} from '@/store/AppointmentStore';
import type { Branch } from '../../utils/Branch';
import BranchesSelection from '../BranchesSelection';

interface BranchSelectionModuleProps {
  branchesData?: Branch[];
  isLoading?: boolean;
  setBranchSearchTerm: (term: string) => void;
}

const BranchSelectionModule: React.FC<BranchSelectionModuleProps> = ({
  branchesData,
  isLoading = false,
  setBranchSearchTerm,
}) => {
  const isInBranchAppointment = useAppointmentStore(
    isInBranchAppointmentSelector,
  );
  const selectedBranch = useAppointmentStore((state) => state.selectedBranch);
  const setSelectedBranch = useAppointmentStore(
    (state) => state.setSelectedBranch,
  );

  const handleSelectBranch = useCallback(
    (branch: Branch) => {
      setSelectedBranch(branch);
      setBranchSearchTerm('');
    },
    [setSelectedBranch, setBranchSearchTerm],
  );

  if (!isInBranchAppointment || selectedBranch) {
    return null;
  }

  return (
    <Stack direction='column' sx={{ width: '100%', height: '100%', pt: 1 }}>
      <Box sx={{ px: 2 }}>
        {isLoading ? (
          <Skeleton variant='rounded' width={300} height={35} />
        ) : (
          <Typography variant='h6' sx={{ textAlign: 'left' }}>
            Please select nearby branches below
          </Typography>
        )}
      </Box>

      <BranchesSelection
        branches={branchesData?.sort((a, b) => a.distance - b.distance) || []}
        selectedBranch={selectedBranch}
        onSelectBranch={handleSelectBranch}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export default BranchSelectionModule;
